import { faEdit } from "@fortawesome/pro-regular-svg-icons";
import { FieldError, useFormContext } from "react-hook-form";

import { FormItem } from "src/base-components/FormItem";
import { Textarea } from "src/base-components/Textarea";
import { ErrorHint } from "src/design-system/ErrorHint";
import { IconButton } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type SecretFieldProps = {
  fieldError?: FieldError;
  displayName: string;
  placeholder: string;
  name: string;
  helpTitle: string;
  isRequired?: boolean;
};

export const SSHSecret: React.FC<SecretFieldProps> = ({
  fieldError,
  displayName,
  placeholder,
  name,
  helpTitle,
  isRequired,
}) => {
  const { register, setValue, watch } = useFormContext();
  const secretRecord = watch(name);
  const enableSecret = () => {
    setValue(name, { ...secretRecord, secret: false, value: null });
  };
  return (
    <FormItem
      description={helpTitle}
      gap="xxs"
      isRequired={isRequired}
      label={displayName}
    >
      {Boolean(fieldError) && <ErrorHint>{fieldError?.message}</ErrorHint>}
      <div className="flex w-full items-start gap-x-2">
        <div className="flex-1">
          <Textarea
            disabled={secretRecord?.secret}
            errored={Boolean(fieldError)}
            {...register(`${name}.value`, {
              required: isRequired ? `${displayName} is required` : false,
            })}
            placeholder={placeholder}
            fullWidth
          />
        </div>
        {secretRecord?.secret && (
          <Tooltip
            placement="right"
            title={`Edit ${displayName.toLowerCase()}`}
            asChild
          >
            <IconButton icon={faEdit} size="xs" onClick={enableSecret} />
          </Tooltip>
        )}
      </div>
    </FormItem>
  );
};
